export function findAssociatedLabel(owner) {
  const previous = owner.previousElementSibling;
  if (previous?.tagName.toLowerCase() === "label") {
    return previous;
  }
  return owner.parentElement?.querySelector("[data-rui-field-label], label.rui-label") ?? null;
}
export function syncFieldLabel(owner, control, options) {
  if (!control || control.hasAttribute("data-rui-field-managed")) {
    return;
  }
  const labelElement = findAssociatedLabel(owner);
  if (labelElement) {
    if (!labelElement.id) {
      labelElement.id = options.labelId;
    }
    if (!labelElement.htmlFor) {
      labelElement.htmlFor = options.controlId;
    }
    control.setAttribute("aria-labelledby", labelElement.id);
    control.removeAttribute("aria-label");
    return;
  }
  if (options.label) {
    control.setAttribute("aria-label", options.label);
    control.removeAttribute("aria-labelledby");
    return;
  }
  control.removeAttribute("aria-label");
  control.removeAttribute("aria-labelledby");
}